'use strict'

import Web3Modal from "@acryptosx/web3modal"
import WalletConnectProvider from "@walletconnect/web3-provider";

window.ACryptoSWeb3 = require('web3')
window.ACryptoSWeb3Modal = Web3Modal
window.ACryptoSWalletConnectProvider = WalletConnectProvider
